import { render, staticRenderFns } from "./upload-template.vue?vue&type=template&id=59059a95&scoped=true&"
import script from "./upload-template.vue?vue&type=script&lang=js&"
export * from "./upload-template.vue?vue&type=script&lang=js&"
import style0 from "./upload-template.vue?vue&type=style&index=0&id=59059a95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59059a95",
  null
  
)

export default component.exports